import i18n from '../../locales/index'
import restful from '@/store/vuex'
// import axios from 'axios'
// import { Message } from 'view-design'

const state = {
  ...restful.states('country_timezone')
}

const getters = {
  ...restful.getters('country_timezone')
}

const actions = {
  ...restful.actions('country_timezones', 'CONFIG'),
}

const mutations = {
  ...restful.mutations('country_timezone')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
